import type { ReactElement } from 'react';
import type { PendingPage } from '@shared/api';
import { PageFrame } from '../pages/Page';
import type { PendingEntry } from '../state/pendingPages';

const LAYOUT_WIREFRAME: Partial<Record<NonNullable<PendingPage['layout']>, string>> = {
  media_full: '/layout-tiles/media-full.svg',
  media_split: '/layout-tiles/media-right.svg',
};

/** Present-mode, full-size version of PendingPageCard (docs/custom-page.md "What the rep sees"). */
export function PendingGallerySlide({ entry }: { entry: PendingEntry }): ReactElement {
  const { pending, status } = entry;
  const wireframe = pending.layout ? LAYOUT_WIREFRAME[pending.layout] : undefined;
  const notAdded = status === 'not_added';
  const title = pending.title ?? 'New page';

  return (
    <PageFrame ariaLabel={notAdded ? `${title} not added` : `${title}, building`}>
      <div className={`pending-gallery-slide${notAdded ? ' pending-gallery-slide-not-added' : ''}`}>
        {wireframe ? (
          <div className="pending-page-wireframe pending-gallery-wireframe">
            <img src={wireframe} alt="" aria-hidden="true" />
            {!notAdded ? <span className="pending-page-shimmer" aria-hidden="true" /> : null}
          </div>
        ) : (
          <div className={`build-slide-skeleton pending-gallery-skeleton${notAdded ? '' : ' build-slide-skeleton-active'}`} aria-hidden="true">
            <span className="build-skeleton-title" />
            <span className="build-skeleton-line build-skeleton-line-short" />
            <span className="build-skeleton-line" />
            <span className="build-skeleton-block" />
          </div>
        )}
        <div className="pending-gallery-slide__caption">
          {pending.title ? <span className="pending-gallery-slide__title">{pending.title}</span> : null}
          <span className="pending-gallery-slide__status">{notAdded ? 'Not added' : 'Building…'}</span>
        </div>
      </div>
    </PageFrame>
  );
}
